
import { useState } from "react"
import { Link } from "react-router-dom"
import { Menu, Search, User, X, ShoppingCart } from "lucide-react"
import { useCart } from "../../context/cart-context"

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isSearchOpen, setIsSearchOpen] = useState(false)
  const { totalItems } = useCart()

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/goods" className="flex items-center">
            <span className="text-xl font-bold text-[#ff9906]">Hoser Global</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/goods" className="text-gray-700 hover:text-[#ff9906]">
              Home
            </Link>
            <Link to="/goods" className="text-gray-700 hover:text-[#ff9906]">
              Products
            </Link>
            <Link to="/goods" className="text-gray-700 hover:text-[#ff9906]">
              Categories
            </Link>
            <Link to="/goods" className="text-gray-700 hover:text-[#ff9906]">
              Deals
            </Link>
            <Link to="/contact-us" className="text-gray-700 hover:text-[#ff9906]">
              Contact
            </Link>
          </nav>

          {/* Search Bar (Desktop) */}
          <div className="hidden md:flex items-center relative flex-1 max-w-xs mx-4">
            <input
              type="text"
              placeholder="Search products..."
              className="w-full py-1.5 pl-8 pr-4 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#ff9906]"
            />
            <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          </div>

          {/* Action Icons */}
          <div className="flex items-center space-x-4">
            {/* Search Icon (Mobile) */}
            <button
              className="md:hidden text-gray-700 hover:text-[#ff9906]"
              onClick={() => setIsSearchOpen(!isSearchOpen)}
            >
              <Search className="h-6 w-6" />
            </button>

            {/* User Account */}
            <Link to="/login" className="text-gray-700 hover:text-[#ff9906]">
              <User className="h-6 w-6" />
            </Link>

            {/* Cart Icon */}
            <Link to="/goods/cart" className="relative p-2">
              <ShoppingCart className="h-6 w-6 text-gray-700" />
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#ff9906] text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {totalItems > 99 ? "99+" : totalItems}
                </span>
              )}
            </Link>

            {/* Mobile Menu Button */}
            <button className="md:hidden text-gray-700 hover:text-[#ff9906]" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              <Menu className="h-6 w-6" />
            </button>
          </div>
        </div>

        {/* Mobile Search Bar */}
        {isSearchOpen && (
          <div className="md:hidden py-2 px-4 border-t border-gray-200">
            <div className="relative">
              <input
                type="text"
                placeholder="Search products..."
                className="w-full py-2 pl-8 pr-4 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#ff9906]"
              />
              <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            </div>
          </div>
        )}
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-50">
          <div className="bg-white h-full w-64 p-4 shadow-lg">
            <div className="flex justify-between items-center mb-6">
              <span className="text-xl font-bold text-[#ff9906]">Menu</span>
              <button className="text-gray-700 hover:text-[#ff9906]" onClick={() => setIsMenuOpen(false)}>
                <X className="h-6 w-6" />
              </button>
            </div>

            <nav className="flex flex-col space-y-4">
              <Link to="/goods" className="text-gray-700 hover:text-[#ff9906] py-2 border-b border-gray-100">
                Home
              </Link>
              <Link to="/goods" className="text-gray-700 hover:text-[#ff9906] py-2 border-b border-gray-100">
                Products
              </Link>
              <Link to="/goods" className="text-gray-700 hover:text-[#ff9906] py-2 border-b border-gray-100">
                Categories
              </Link>
              <Link to="/goods" className="text-gray-700 hover:text-[#ff9906] py-2 border-b border-gray-100">
                Deals
              </Link>
              <Link to="/contact-us" className="text-gray-700 hover:text-[#ff9906] py-2 border-b border-gray-100">
                Contact
              </Link>
              <Link to="/login" className="text-gray-700 hover:text-[#ff9906] py-2 border-b border-gray-100">
                My Account
              </Link>
              <Link to="/goods/orders" className="text-gray-700 hover:text-[#ff9906] py-2 border-b border-gray-100">
                My Orders
              </Link>
            </nav>
          </div>
        </div>
      )}
    </header>
  )
}
